
<template>
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
       Locate Active Resources
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li><router-link to="/locate-resources">Back</router-link></li>        
        <li class="active">Locate Resources</li>
      </ol>
    </section>

    <section class="content">
        <div class="row">
        <div class="col-xs-12">
          <div class="box">
            <div class="box-body">
              <div class="col-xs-3 col-md-3 col-lg-3" style="padding-right: 5px; padding-left: 5px;">
                <form @submit.prevent="onSubmitFilters" action="#" @keydown="onFormKeyDown" method="post">
                  <div class="panel panel-default">
                    <div class="panel-heading">
                      <h3 class="panel-title">Map Filters</h3>
                    </div>
                    <div class="panel-body">
                      <div class="row">
                        <div class="col-md-12 col-lg-12 col-xs-12">
                          <div class="form-group">
                          <label for="name">Search Place</label>
                              <GmapAutocomplete ref="autocomplete" class="form-control" v-bind:class="{'form-group--error': submitted && $refs.autocomplete.$refs.input.value && gRowObj.name != $refs.autocomplete.$refs.input.value }" @place_changed="getPlace"></GmapAutocomplete>
                              <span v-if="submitted && $refs.autocomplete.$refs.input.value && gRowObj.name != $refs.autocomplete.$refs.input.value" class="text-red pull-right">Please select valid place</span>
                          </div>
                        </div>
                      </div>

                       <div class="row">
                        <div class="col-md-12 col-lg-12 col-xs-12">                         
                              <div class="form-group">
                              <label for="name">Country</label>
                              <nv-select class="form-control"
                              id="country_id" v-model="gRowObj.country_id">
                                <option value="">--Choose a Country--</option>
                                <option v-for="data in countryList" 
                                :selected="data.country_id === gRowObj.country_id" :key="data.country_id" :value="data.country_id">{{data.country_name}}</option>                    
                              </nv-select>
                            </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-12 col-lg-12 col-xs-12">                         
                            <div class="form-group">
                              <label for="Client">Customer</label>
                              <nv-select class="form-control"
                              id="Client" v-model="gRowObj.client_id">
                                <option value="">--Choose a Option--</option>
                                <option v-for="data in clientList" 
                                :selected="data.id === gRowObj.client_id" :key="data.id" :value="data.id">{{data.name}}</option>                    
                              </nv-select>
                            </div>
                        </div>
                      </div>


                      <div class="row">
                        <div class="col-md-12 col-lg-12 col-xs-12">
                          <div class="form-group">
                          <label for="label-custom" style="margin-bottom: 0px">Custom Query</label>
                          <span class="ab-hint-text" style="margin-bottom: 5px">(The query should only return referral resource id)</span>
                          <textarea v-model="gRowObj.custom_query" rows="4" class="form-control" placeholder="Enter the custom query here"/>
                          </div>
                        </div>
                      </div>

                  </div>
                </div>

                  <div class="row">
                  </div>
                  <div class="row">
                    <div class="action-button">
                      <button type="button" class="btn btn-primary" @click="onResetFilters">Reset</button>
                      <input type="submit" class="btn btn-primary margin-left-20px" value="Submit">
                    </div>
                  </div>
                </form>
              </div>
              <div class="col-xs-9 col-md-9 col-lg-9" style="padding-right: 5px; padding-left: 5px;">
              <GmapMap
                :center="centerCoordinate"
                :zoom="userMarker ? 8 : 5"
                map-type-id="terrain"
                ref="map"
                style="height: calc(100vh - 190px)"
              >
                <GmapMarker
                  :key="index"
                  v-for="(m, index) in markers"
                  :position="m"
                  :clickable="true"
                  :draggable="false"
                  @click="openInfoWindow(m);"
                >
                  <GmapInfoWindow :position="m.position" :opened.sync="m.opened">
                    <!-- Content for the info window -->
                    <div class='info_content'>
                      <strong>{{m.label}}</strong><p>{{m.address || ''}}</p>
                    </div>
                  </GmapInfoWindow>
                </GmapMarker>
                <GmapMarker
                  v-if="userMarker"
                  :position="userMarker"
                  :clickable="true"
                  :draggable="false"
                  @click="center=userMarker"
                  :icon="userIcon"
                />
              </GmapMap>
              </div>
            </div>
          </div>
        </div>
      </div>

    </section>
    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>
    </div>
</template>
<script>
import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import api from '../../../utils/api'
import userIcon from '../../assets/location.png'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBsrXR_8B9AumeSZFY-ataEWCYepVqLJPY',  // India JS Map key
    libraries: 'places'
  }
})

export default {
  name: 'modal',
  data () {
    return {
      userIcon: userIcon,
      centerCoordinate: {},
      userCenter: {},
      inputValue: '',
      clickUrlDomain: '',
      userMarker: null,
      center: {},
      loading: false,
      isEdit: false,
      clientList: [],
      countryList: [],
      markers: [],
      gRowObj: {
        name: '',
        client_id: '',
        country_id: '',
        custom_query: ''
      },
      submitted: false
    }
  },
  methods: {
    openInfoWindow (markerObj) {
      this.markers.forEach(marker => {
        marker.opened = marker.id === markerObj.id
      })
    },
    getCenter () {
      if (this.userMarker) {
        this.centerCoordinate = {lat: this.userMarker.lat, lng: this.userMarker.lng}
      } else {
        // Custom location based on dashboard
        var domainname = window.location.hostname
        if (['dashboard.mynivi.in', 'india-dashboard-staging.herokuapp.com', 'localhost'].includes(domainname)) {
          this.centerCoordinate = { lat: 20.593684, lng: 78.96288 }
        } else {
          this.centerCoordinate = { lat: 4.45, lng: 24 }
        }
      }
    },
    async getClientList () {
      return new Promise(resolve => {
        api.buildRequest('getClientData', 'POST').then(({ data }) => {
          this.clientList = data.payload
          resolve()
        }).catch(({ response }) => {
          resolve(true)
          this.loading = false
          this.$swal({
            type: 'error',
            text: response ? response.data.payload.message : 'An error occurred'
          })
        })
      })
    },
    async getCountryList () {
      return new Promise(resolve => {
        api.buildRequest('getCountryList', 'POST').then(({ data }) => {
          this.countryList = data.payload.filter(item => item.country_name !== 'Global')
          resolve()
        }).catch(({ response }) => {
          resolve(true)
          this.loading = false
          this.$swal({
            title: 'Failure',
            type: 'error',
            text: response ? response.data.payload.message : 'An error occurred'
          })
        })
      })
    },
    getPlace (event) {
      if (event.geometry) {
        this.submitted = false
        this.gRowObj.name = this.$refs.autocomplete.$refs.input.value
        this.userCenter = {
          lat: event.geometry.location.lat(),
          lng: event.geometry.location.lng()
        }
      } else {
        this.gRowObj.name = ''
      }
    },
    onFormKeyDown (event) {
      if (event.keyCode === 13) {
        event.preventDefault()
      }
    },
    onSubmitFilters () {
      this.submitted = true
      if (this.$refs.autocomplete.$refs.input.value && this.$refs.autocomplete.$refs.input.value !== this.gRowObj.name) {
        return
      }
      if (!this.$refs.autocomplete.$refs.input.value) {
        this.gRowObj.name = ''
      }
      if (this.gRowObj.name) {
        this.userMarker = {label: this.gRowObj.name, ...this.userCenter}
        this.getCenter()
      } else this.userMarker = null
      this.getResouces()
    },
    onResetFilters () {
      this.gRowObj = {
        name: '',
        client_id: '',
        country_id: '',
        custom_query: ''
      }
      this.$refs.autocomplete.$refs.input.value = ''
      this.userMarker = null
      this.markers = []
    },
    async getResouces () {
      const param = {
        country_id: this.gRowObj.country_id,
        client_id: this.gRowObj.client_id,
        custom_query: this.gRowObj.custom_query.replace(/;$/, '')
      }
      this.submitted = false
      this.loading = true
      return new Promise(resolve => {
        api.buildRequest('getPhysicalResourcesForMap', 'GET', param).then(({ data }) => {
          this.markers = data.payload
          this.loading = false
          if (data.payload.length === 0) {
            this.$swal({
              type: 'info',
              text: 'No resources found'
            })
          }
          resolve()
        }).catch(({ response }) => {
          resolve(true)
          this.loading = false
          this.$swal({
            type: 'error',
            text: response ? response.data.payload.message : 'An error occurred'
          })
        })
      })
    }
  },
  async mounted () {
    this.getCenter()
    this.getCountryList()
    this.getClientList()
  }
}
</script>
<style>
.info_content {
  max-width: 200px;
  font-family: poppins-extralight,poppins,sans-serif;
}
</style>



// WEBPACK FOOTER //
// locateResources.vue?6ece2d49